enum Language {
  english = "en",
  german = "de",
  keys = "keys",
}

export default Language;
